import { gql } from "@apollo/client";

export default gql`
  query getUpdateNotification{
    getUpdateNotification{
        success
        data{
            updatedAt
            message
        }
        code
        message
    }
}
`
